<div>
    <span class="header-otp">{{ placeholder || ('inputCodeOtp.defaultPlaceholder' | transloco) }}</span>
    <p-inputotp
    [(ngModel)]="value"
    (ngModelChange)="valueChange.emit($event)"
    [integerOnly]="integerOnly"
    [length]="length"
    size="large"></p-inputotp>
</div>